export default function Menu(){
    $(document).on('scroll', changeHeaderBg);

    function changeHeaderBg() {
        if ( window.scrollY > 101 ) {
            $("#header").addClass('navbar-light')
            $("#header").addClass('fixed-top')
        } else {
            $("#header").removeClass('navbar-light')
            $("#header").removeClass('fixed-top')
        }
    }
}